import { bookingConditions } from 'pages/locations'

export default [
  //booking conditions
  { path: '/locations/:id/booking-conditions', name: 'locations.bookingConditions', component: bookingConditions
    , meta:{permits:['location_user', 'location_booking_conditions']}},
]
